import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  "class": "border-gray p-3 rounded-3-half"
};
var _hoisted_2 = {
  key: 1,
  "class": "card rounded-3-half p-4 card-border text-center bg-transparent border-0"
};
var _hoisted_3 = {
  key: 2,
  "class": "card rounded-3-half p-4 card-border text-center bg-transparent border-0"
};
var _hoisted_4 = {
  key: 3,
  "class": "m-1"
};
var _hoisted_5 = {
  "class": "d-md-flex justify-content-between align-items-center mb-3"
};
var _hoisted_6 = {
  "class": "font-size-14 font-weight-semibold mb-0 font-family-open-sans"
};
var _hoisted_7 = {
  "class": "font-size-10 sh-text-green border-gray rounded-1 px-1"
};
var _hoisted_8 = {
  "class": "row g-3"
};
var _hoisted_9 = {
  "class": "text-center mt-4"
};
import ProductExpansionIdeaCard from './ProductExpansionIdeaCard.vue';
import ProductExpansionIntro from './ProductExpansionIntro.vue';
export default {
  __name: 'ProductExpansionResults',
  props: {
    query: {
      type: String,
      required: true
    },
    ideas: {
      type: Array,
      required: true
    },
    hasSearchQuery: {
      type: Boolean,
      required: true
    },
    isLoading: {
      type: Boolean,
      "default": false
    }
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _component_BTooltip = _resolveComponent("BTooltip");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!__props.hasSearchQuery ? (_openBlock(), _createBlock(ProductExpansionIntro, {
        key: 0
      })) : __props.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [_createElementVNode("div", {
        "class": "font-weight-semibold mb-1"
      }, "Generating expansion ideas...", -1), _createElementVNode("div", {
        "class": "opacity-75 font-size-12"
      }, "Searching broadly for related products with strong market signals.", -1)]))) : !__props.ideas.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[1] || (_cache[1] = [_createElementVNode("div", {
        "class": "font-weight-semibold mb-1"
      }, "No expansion ideas found", -1), _createElementVNode("div", {
        "class": "opacity-75 font-size-12"
      }, "Try a broader search term or a more established product name.", -1)]))) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("h5", _hoisted_6, "Expansion Ideas for \"" + _toDisplayString(__props.query) + "\"", 1), _createElementVNode("span", _hoisted_7, _toDisplayString(__props.ideas.length) + " Ideas Generated", 1)]), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.ideas, function (idea) {
        return _openBlock(), _createElementBlock("div", {
          key: idea.id,
          "class": "col-md-4"
        }, [_createVNode(ProductExpansionIdeaCard, {
          idea: idea
        }, null, 8, ["idea"])]);
      }), 128))]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_BTooltip, {
        "class": "sh-tooltip-dark-sm",
        placement: "top"
      }, {
        target: _withCtx(function () {
          return _cache[2] || (_cache[2] = [_createElementVNode("span", {
            "class": "d-inline-block",
            tabindex: "0"
          }, [_createElementVNode("button", {
            type: "button",
            "class": "btn btn-outline-white btn-sm rounded-2 font-size-11 d-flex align-items-center gap-1 px-2 text-nowrap justify-content-center px-5 disabled-outline",
            disabled: ""
          }, [_createElementVNode("img", {
            src: "/img/v5/db_ic_refresh.svg"
          }), _createTextVNode(" Generate more ideas ")])], -1)]);
        }),
        "default": _withCtx(function () {
          return [_cache[3] || (_cache[3] = _createTextVNode(" Coming soon "))];
        }, undefined, true),
        _: 1
      })])]))]);
    };
  }
};